var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"game",style:({height: _vm.height,width:_vm.width})},[_c('iframe',{attrs:{"id":"receiverIframe","src":"","frameborder":"0","width":"100%","height":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }